import { Box, Stack, Typography } from '@mui/material';

import { Icon, Mask } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { columnsSubRow } from '@flows/private/financial/pages/CoparticipationPreviewReport/constants/columns';

import {
  StyledButton,
  StyledCardMobile,
  StyledStack,
  StyledTypography,
} from './styles';
import type { CoparticipationCardMobileProps } from './types';
import { StyledCollapse } from '../../styles';
import { CoparticipationSubTable } from '../CoparticipationSubTable';

export function CoparticipationCardMobile({
  row,
  open,
  onToggle,
}: CoparticipationCardMobileProps) {
  return (
    <StyledCardMobile open={open}>
      <StyledStack
        gap={2}
        flexDirection="column"
        justifyContent="space-between"
        p={2}
        open={open}
      >
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          gap={4}
        >
          <Typography
            variant="text"
            fontWeight={400}
            color={NEW_COLORS.GRAYSCALE[700]}
            width="100%"
          >
            {row.partnerCompany}
          </Typography>
          <Typography
            variant="text"
            fontWeight={700}
            color={NEW_COLORS.GRAYSCALE[700]}
            width="100%"
          >
            {Mask.currency(Number(row.totalCoparticipation))}
          </Typography>
          <Typography
            variant="text"
            fontWeight={400}
            color={NEW_COLORS.GRAYSCALE[700]}
            width="100%"
          >
            {row.cancellationDate ?? '-'}
          </Typography>
        </Stack>
        <Stack flexDirection="row">
          <Stack justifyContent="flex-start" width="100%">
            <Typography
              variant="smallText"
              fontWeight={400}
              color={NEW_COLORS.GRAYSCALE[400]}
              mb={1}
            >
              Beneficiário
            </Typography>
            <Typography
              variant="smallText"
              fontWeight={400}
              color={NEW_COLORS.GRAYSCALE[700]}
            >
              {row.beneficiaryCode}
            </Typography>
            <StyledTypography
              variant="text"
              fontWeight={700}
              color={NEW_COLORS.GRAYSCALE[700]}
            >
              {row.beneficiaryName}
            </StyledTypography>
            <Typography
              variant="smallText"
              fontWeight={400}
              color={NEW_COLORS.GRAYSCALE[700]}
            >
              {row.beneficiaryDocument}
            </Typography>
          </Stack>
          <Stack justifyContent="flex-start" width="100%">
            <Typography
              variant="smallText"
              fontWeight={400}
              color={NEW_COLORS.GRAYSCALE[400]}
              mb={1}
            >
              Titular
            </Typography>
            <Typography
              variant="smallText"
              fontWeight={400}
              color={NEW_COLORS.GRAYSCALE[700]}
            >
              {row.holderCode}
            </Typography>
            <StyledTypography
              variant="text"
              fontWeight={700}
              color={NEW_COLORS.GRAYSCALE[700]}
            >
              {row.holderName}
            </StyledTypography>
            <Typography
              variant="smallText"
              fontWeight={400}
              color={NEW_COLORS.GRAYSCALE[700]}
            >
              {row.holderDocument}
            </Typography>
          </Stack>
        </Stack>
      </StyledStack>
      <StyledCollapse in={open} timeout="auto" unmountOnExit>
        <Box overflow={'auto'} mb={2}>
          <CoparticipationSubTable
            details={row.beneficiaryProcedures}
            columnsSubRow={columnsSubRow}
          />
        </Box>
      </StyledCollapse>
      <Stack px={2}>
        <StyledButton
          aria-label="expand row"
          variant="contained"
          onClick={() => onToggle(row.id)}
          fullWidth
          disableElevation
          open={open}
        >
          <Stack gap={1} flexDirection="row" alignItems="center">
            <Typography
              variant="subtitle1"
              fontWeight={600}
              color={open ? NEW_COLORS.SECONDARY[600] : NEW_COLORS.BASE.BLACK}
              minWidth="105px"
            >
              {open ? 'Mostrar menos' : 'Mostrar mais'}
            </Typography>
            <Icon
              name={
                open ? 'actions-b2b-chevron-up' : 'actions-b2b-chevron-down'
              }
              color={open ? NEW_COLORS.SECONDARY[600] : NEW_COLORS.BASE.BLACK}
              size={24}
            />
          </Stack>
        </StyledButton>
      </Stack>
    </StyledCardMobile>
  );
}
